"use client";

import { SectionHeader } from "@/components/util/section-header";

import ColorVariationCarouselSwiper from "./color-variation-carousel-swiper";

import {
  useColorVariationCarousel,
  UseColorVariationCarouselProps,
} from "./use-color-variation-carousel";

export type ColorVariationCarouselProps = UseColorVariationCarouselProps;

function ColorVariationCarousel(props: ColorVariationCarouselProps) {
  const {
    className,
    styles,
    componentProps,
    sectionName,
    data: { title, description, list },
  } = useColorVariationCarousel(props);

  return (
    <section
      {...componentProps}
      className={styles.base({ className })}
      data-section-name={sectionName}
    >
      <div className={styles.container()}>
        <div className={styles.wrapper()}>
          <header className={styles.header()}>
            <SectionHeader
              title={title}
              description={description}
              anchor={componentProps.id}
            />
          </header>

          <ColorVariationCarouselSwiper list={list} styles={styles} />
        </div>
      </div>
    </section>
  );
}

export default ColorVariationCarousel;
